import { render } from "./Hobbies.vue?vue&type=template&id=b506065c"
import script from "./Hobbies.vue?vue&type=script&lang=js"
export * from "./Hobbies.vue?vue&type=script&lang=js"

import "./Hobbies.vue?vue&type=style&index=0&id=b506065c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__